export function calculateChunkCount(
  dataSize: number,
  chunkSize: number,
): number {
  return Math.floor(dataSize / chunkSize) * chunkSize < dataSize
    ? Math.floor(dataSize / chunkSize) + 1
    : Math.floor(dataSize / chunkSize);
}
